import { LOGOUT_EVENT_KEY } from "../services/tokenStorage";

const STORE_VERSION = "0.1";
const STORE_VERSION_KEY = 'store-version';
const STATE_KEY = 'state';

export const loadState = () => {
    try {
        const storedVersion = localStorage.getItem(STORE_VERSION_KEY);
        if (storedVersion !== STORE_VERSION) return undefined;

        const serializedState = localStorage.getItem(STATE_KEY);
        if (serializedState === null) { return undefined; } // guard
        return JSON.parse(serializedState) || undefined;
    } catch (err) {
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(STATE_KEY, serializedState);
        localStorage.setItem(STORE_VERSION_KEY, STORE_VERSION);
    } catch (err) {
        // ignore
    }
};

export const destroyState = () => {
    try {
        localStorage.removeItem(STATE_KEY);
        localStorage.removeItem(STORE_VERSION_KEY);
        localStorage.setItem(LOGOUT_EVENT_KEY, Date.now());
    } catch (err) {
        // ignore
    }
};
